module.exports = __webpack_public_path__ + "static/media/2488754.4405b2f6.png";